import { setupI18n } from '@umituz/web-localization/setup';
import enUS from './locales/en-US.json';
import trTR from './locales/tr-TR.json';
import deDE from './locales/de-DE.json';
import esES from './locales/es-ES.json';
import ruRU from './locales/ru-RU.json';

// Configure i18n with all supported languages
const i18nInstance = setupI18n({
  resources: {
    'en-US': { translation: enUS.translation },
    'tr-TR': { translation: trTR.translation },
    'de-DE': { translation: deDE.translation },
    'es-ES': { translation: esES.translation },
    'ru-RU': { translation: ruRU.translation },
  },
  defaultLng: 'en-US',
  fallbackLng: 'en-US',
  seo: {
    titleKey: 'common.seoTitle',
    descriptionKey: 'common.seoDescription',
    defaultImage: 'https://umituz.com/og-image.jpg',
    twitterHandle: '@umituz'
  }
});

export default i18nInstance;
